import { render } from "./HomeSixPage.vue?vue&type=template&id=dd8babd4&ts=true"
import script from "./HomeSixPage.vue?vue&type=script&lang=ts"
export * from "./HomeSixPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__